import { type HTMLAttributes, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

/**
 * Loading placeholder. Always `aria-hidden` — the live region announcing
 * "loading" belongs on the container, not on every grey box.
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>): ReactNode {
  return (
    <div
      aria-hidden="true"
      className={cn('relative overflow-hidden rounded-sm bg-muted', className)}
      {...props}
    >
      <span className="shimmer absolute inset-0 opacity-60" />
    </div>
  )
}

export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }): ReactNode {
  return (
    <div className={cn('space-y-2', className)}>
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton
          key={index}
          className={cn('h-3.5', index === lines - 1 ? 'w-2/3' : 'w-full')}
        />
      ))}
    </div>
  )
}
